import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bullhorn" })
], -1)
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Información llamada entrante ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", null, "[Campaña]", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { style: {"user-select":"all"} }, "Comentario", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Datos", -1)
const _hoisted_8 = { class: "cell-item" }

import { ref, computed } from "vue";
import { InfoFilled, Document } from "@element-plus/icons-vue";
import { CampaingModule } from "@/store/modules/Campaign";
import { putFirstLetterInUpperCase } from "@/util/utils";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const drawer = computed(() => {
	return CampaingModule.getShowDrawer;
});
const direction = ref("rtl");
const click = () => {
	CampaingModule.setShowDrawer(true);
};
const data = computed(() => {
	return CampaingModule.getClientData;
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tooltip, { content: "Consultar datos de campaña" }, {
      default: _withCtx(() => [
        _createVNode(_component_base_button, {
          class: "",
          type: "info",
          size: "sm",
          onClickCapture: click
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(drawer),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(drawer) ? (drawer).value = $event : null)),
      "show-close": false,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(CampaingModule).setShowDrawer(false))),
      "append-to-body": false,
      "close-on-press-escape": true,
      width: "50%"
    }, {
      header: _withCtx(({ titleId, titleClass }) => [
        _createElementVNode("h3", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, _hoisted_5, 10, _hoisted_2)
      ]),
      default: _withCtx(() => [
        _hoisted_6,
        _createElementVNode("p", null, _toDisplayString(_unref(data).comentario ? _unref(data).comentario : "Sin comentario"), 1),
        _hoisted_7,
        _createVNode(_component_el_descriptions, {
          class: "margin-top",
          title: "",
          column: 1,
          border: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(data).datos), ([key, value]) => {
              return (_openBlock(), _createBlock(_component_el_descriptions_item, { key: key }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(putFirstLetterInUpperCase)(key)), 1)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(value), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})